/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function MediaAcceptProfilesModalController(
    this: JS5Object,
    MediaAcceptProfileService: JS5Object,
    uiGridConstants: JS5Object
) {

    let searchText: string = '';

    const getData = () => {
        let criteria = {
            fetchLimit: 0,
            includeHidden: false,
            searchString: ''
        };

        this.loadingIndicator.show = true;
        MediaAcceptProfileService.getAcceptProfiles(criteria).then((profiles: JS5Object) => {
            if (this.resolve.mediaAcceptProfileType) {
                this.gridOptions.data = _.filter(profiles, {type: this.resolve.mediaAcceptProfileType});
            } else {
                this.gridOptions.data = profiles;
            }
            this.loadingIndicator.show = false;
        });
    };


    //===============//
    // Search Filter //
    //===============//

    const processGridFilter = (renderableRows: JS5Object[]) => {
        renderableRows.forEach((row: JS5Object) => {
            if (_.includes(_.toLower(row.entity.name), _.toLower(searchText))) {
                row.visible = true;
            } else {
                row.visible = false;
            }
        });
        return renderableRows;
    };

    this.executeSearch = (newSearchText: string): void => {
        searchText = newSearchText;
        this.gridApi.grid.refresh();
    };

    this.onSearchRefresh = (newSearchText: string) => {
        searchText = newSearchText;
        getData();
    };


    //======//
    // Grid //
    //======//

    const columnDefinitions = [
        {
            field: 'name',
            displayName: 'Name',
            cellTemplate: 'components/visual/grid/padded-base-tooltip-template.html'
        }
    ];

    this.gridOptions = {
        rowSelection: true,
        enableRowHeaderSelection: true,
        enableSelectAll: true,
        enableColumnResizing: true,
        enablePaginationControls: false,
        enableSorting: true,
        enableColumnMenus: false,
        enableFullRowSelection: true,
        enableHorizontalScrollbar: uiGridConstants.ALWAYS,
        enableVerticalScrollbar: uiGridConstants.ALWAYS,
        rowHeight: 26,
        multiSelect: true,
        columnDefs: columnDefinitions,
        onRegisterApi: (gridApi: JS5Object) => {
            this.gridApi = gridApi;
            this.gridApi.grid.registerRowsProcessor(processGridFilter, 200);
        },
        rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
    };


    //===================//
    // Template Response //
    //===================//

    this.disableOKButton = () => {
        return this.gridApi.selection.getSelectedRows().length === 0;
    };

    this.onOK = () => {
        this.close({
            $value: this.gridApi.selection.getSelectedRows()
        });
    };

    this.cancel = () => {
        this.dismiss({$value: 'cancel'});
    };


    //=================//
    // Lifecycle Hooks //
    //=================//

    this.$onInit = () => {
        this.loadingIndicator = {
            backdrop: true,
            show: false,
            title: 'Working',
            message: 'Please wait...'
        };
        getData();
    };

}

angular.module('prism-ui.package').component('mediaAcceptProfilesModal', {
    templateUrl: 'system/templates/packageAcceptTemplates/editView/mediaAcceptProfileMembers/modals/mediaAcceptProfiles/media-accept-profiles-modal-template.html',
    controller: MediaAcceptProfilesModalController,
    bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<',
    }
});
